import axios from "axios";
import {buildQuery} from "utils/queryUtils";

export const findSendOTPForeigns = (headers, params) => {
    let query = buildQuery(params, ["idNumber"]);
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/send-otp${query}`, {
        headers
    })
}
